import { Component, Input, OnInit } from '@angular/core';
import { Proforma, ProformaService } from '../proforma';
import { AlertService } from '@app/_services';
import { first } from 'rxjs';
import { LazyLoadEvent } from 'primeng/api';
import { OwnerLeadProfile } from '../owner-lead-profile/owner-lead-profile';
import { OwnerLeadProfileService } from '../owner-lead-profile/owner-lead-profile.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { OwnerLeadProfileComponent } from '../owner-lead-profile/owner-lead-profile/owner-lead-profile.component';
import { RealtorProfileService } from '../realtor-profile/realtor-profile.service';
import { ProformaComponent } from '../proforma/proforma/proforma.component';
import { RealEstateService } from '../real-estate/real-estate.service';
import { RealEstate } from '../real-estate/real-estate';
import Utils from '../_shared/utils';
import { Msg } from '../msg';
import {
	MessageService,
	ConfirmationService,
} from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SendFullMailComponent } from '../msg/send-full-mail/send-full-mail.component';

@Component({
    selector: 'app-bizdev-dashboard',
    templateUrl: './bizdev-dashboard.component.html',
    styleUrls: ['./bizdev-dashboard.component.css'],
    providers: [DialogService, MessageService, ConfirmationService],
    standalone: false
})
export class BizdevDashboardComponent implements OnInit {
  proformas: any[]=[];
  showSearchUI= true;
  // paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	recordTotal1: number;
	lazyLoadEvent: LazyLoadEvent;
	lazyLoadEvent1: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() hideTitle = true;

	proformaSearchForm:any = {};
	ownerLeadSearchForm:any = {};

	ownerLeadProfiles: any;
	ownerLeadProfile: OwnerLeadProfile;
	realtorProperties: any[]=[];
	proformaObj: any;
	proforma: Proforma;
	realEstates: any;
	realEstate: RealEstate;
	msg: Msg;
	shareProformaEmail: any = 'https://www.kbmresorts.com/proforma/CONFID/honua-kai/hkh-236';

  constructor(
    private proformaService: ProformaService,
	private realEstateService: RealEstateService,
	private ownerLeadProfileService: OwnerLeadProfileService,
    private alertService: AlertService,
	private messageService: MessageService,
	private dialogService: DialogService,
	private realtorProfileService: RealtorProfileService,
	private dialog: MatDialog,
  ) { }

  columns: any[] = [
		{ field: 'sentDate', header: 'Sent Date', width: 'auto' },
		{ field: 'senderName', header: 'Sender Name', width: 'auto' },
		{ field: 'recipientMail', header: 'Recipient Mail', width: 'auto' },
		{ field: 'subjAdrDevelopmentName', header: 'Dev Name', width: 'auto' },
		{ field: 'subjAdrUnit', header: 'Unit', width: 'auto' },
		{ field: 'subjAdrCity', header: 'City', width: 'auto' },
		{ field: 'opened', header: 'Opened?', width: 'auto' },
	];

	columns1: any[] = [
		{ field: 'lastName', header: 'Owner', width: 'auto' },
		{ field: 'createDate', header: 'Create Date', width: 'auto' },
		{ field: 'lastUpdate', header: 'Last Update', width: 'auto' },
		{ field: 'assignToSalesAgnt1', header: 'Agent1', width: 'auto' },
		{ field: 'assignToSalesAgnt2', header: 'Agent2', width: 'auto' },
		{ field: 'assignToSalesAgnt3', header: 'Agent3', width: 'auto' },
		{ field: 'assignToSalesAgnt4', header: 'Agent4', width: 'auto' },
		{ field: 'assignToMgr', header: 'Manager', width: 'auto' },
		{ field: 'subjAdrLocationDesc', header: 'Address', width: 'auto' },
		{ field: 'listingStatus', header: 'Status', width: 'auto' },
		{ field: 'lastName', header: 'Realtor', width: 'auto' },
	];

	columns2: any[] = [
		{allowSort: false, field: 'propertyImage', header: 'Image', width: 'auto' },
		{allowSort: true, field: 'statusDesc', header: 'Status', width: 'auto' },
		{allowSort: true, field: 'listingDate', header: 'Listing Date', width: 'auto' },
		{allowSort: true, field: 'listingPrice', header: 'Price', width: 'auto' },
		{allowSort: true, field: 'kbmPropertyType', header: 'KBM PropertyType', width: 'auto' },
		{allowSort: true, field: 'address', header: 'Address', width: 'auto' },
		{allowSort: true, field: 'listingAgentName', header: 'Realtor1 Name', width: 'auto' },
		{allowSort: true, field: 'listingAgentEmail', header: 'Realtor1 Email', width: 'auto' },
		{allowSort: true, field: 'listingAgentPhone', header: 'Realtor1 Phone', width: 'auto' },
	];

  propertyOptions: any = this.realEstateService.propertyOptions;

  ngOnInit(): void {
	this.fetchRealtor();
    this.getAllSentEmailProforma(this.proformaSearchForm);
	this.getAllOwnerLeadProfile(this.ownerLeadSearchForm);
  }

  getAllOwnerLeadProfile(searchForm) {
			try {
				this.ownerLeadProfileService.findAllByDate(searchForm)
					.subscribe(
						res => {
							console.log('findAllByDate: ' + JSON.stringify(res));
							this.ownerLeadProfiles = res.data.ownerLeadProfiles;
							return this.ownerLeadProfiles;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
	}

	getAllSentEmailProforma(searchForm) {
		try {
			this.proformaService.getAllSentEmailProforma(searchForm)
				.subscribe(
					res => {
						console.log('getAllSentEmailProforma: ' + JSON.stringify(res));
						this.proformas = res.data.proformaMsgs;
						return this.proformas;
					},
					err => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
}

	onSearchSubmit(searchForm: any) {
		this.proformaSearchForm.sentStartDate = this.addLocalTimeToDateTime(searchForm.saleDateStart);
		this.proformaSearchForm.sentEndDate = this.addLocalTimeToDateTime(searchForm.saleDateEnd);
		this.ownerLeadSearchForm.createDateStart = this.addLocalTimeToDateTime(searchForm.saleDateStart);
		this.ownerLeadSearchForm.createDateEnd = this.addLocalTimeToDateTime(searchForm.saleDateEnd);
		this.getAllSentEmailProforma(this.proformaSearchForm);
		this.getAllOwnerLeadProfile(this.ownerLeadSearchForm);
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	onWeeklyReport() {
		let sentStartDate = new Date();
		sentStartDate.setDate(sentStartDate.getDate() - 6);
		let saleDateEnd = new Date();
		this.proformaSearchForm.sentStartDate = this.addLocalTimeToDateTime(sentStartDate);
		this.proformaSearchForm.sentEndDate = this.addLocalTimeToDateTime(saleDateEnd);
		this.ownerLeadSearchForm.createDateStart = this.addLocalTimeToDateTime(sentStartDate);
		this.ownerLeadSearchForm.createDateEnd = this.addLocalTimeToDateTime(saleDateEnd);
		this.getAllSentEmailProforma(this.proformaSearchForm);
		this.getAllOwnerLeadProfile(this.ownerLeadSearchForm);
	}

	onMonthlyReport() {
		let sentStartDate = new Date();
		sentStartDate.setDate(sentStartDate.getDate() - 29);
		let saleDateEnd = new Date();
		this.proformaSearchForm.sentStartDate = this.addLocalTimeToDateTime(sentStartDate);
		this.proformaSearchForm.sentEndDate = this.addLocalTimeToDateTime(saleDateEnd);
		this.ownerLeadSearchForm.createDateStart = this.addLocalTimeToDateTime(sentStartDate);
		this.ownerLeadSearchForm.createDateEnd = this.addLocalTimeToDateTime(saleDateEnd);
		this.getAllSentEmailProforma(this.proformaSearchForm);
		this.getAllOwnerLeadProfile(this.ownerLeadSearchForm);
	}

	onYearlyReport() {
		let sentStartDate = new Date();
		sentStartDate.setDate(sentStartDate.getDate() - 364);
		let saleDateEnd = new Date();
		this.proformaSearchForm.sentStartDate = this.addLocalTimeToDateTime(sentStartDate);
		this.proformaSearchForm.sentEndDate = this.addLocalTimeToDateTime(saleDateEnd);
		this.ownerLeadSearchForm.createDateStart = this.addLocalTimeToDateTime(sentStartDate);
		this.ownerLeadSearchForm.createDateEnd = this.addLocalTimeToDateTime(saleDateEnd);
		this.getAllSentEmailProforma(this.proformaSearchForm);
		this.getAllOwnerLeadProfile(this.ownerLeadSearchForm);
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-ownerLeadProfile-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			// if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
			// }
			event.multiSortMeta = [];
			event.multiSortMeta.push({ field: 'createDate', order: -1 });

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerLeadProfileService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.ownerLeadProfiles = res.data.ownerLeadProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.ownerLeadProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelectProforma(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.fetchProformaById(event.data.proformaId)
	}

	/*********
		* Edit Button
		*
		*/
		onOpenFormEdit(ownerLeadProfile: OwnerLeadProfile) {

			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				ownerLeadProfile: ownerLeadProfile,
				title: 'Edit Owner Lead Profile'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(OwnerLeadProfileComponent, dialogConfig);

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);

					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
					//this.updateOwnerLeadProfileCB(data);

					this.getAllOwnerLeadProfile(data);
				});

			dialogRef.componentInstance.doDelete.subscribe(
				data => {
					console.log('Dialog output:', data);

					// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
					this.getAllOwnerLeadProfile(data);

					// close the dialogBox
					dialogRef.close();
				});
		}

		formAddOwnerLeadProfile() {
			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				title: "Add Owner Lead Profile",
				isDisplayPropertyProfile : true
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(
				OwnerLeadProfileComponent,
				dialogConfig
			);

			dialogRef.componentInstance.doAdd.subscribe((data) => {
				console.log("Dialog output:", data);

				this.ownerLeadProfiles = [];
				this.getAllOwnerLeadProfile(this.ownerLeadSearchForm);

				 // close the dialogBox
				dialogRef.close();

			});
		}

		fetchRealtor() {
			try {
				this.realtorProfileService.findAllForRequiredFields().subscribe(
					(res) => {
						// console.log('findAllPropertiesSummary: ' + JSON.stringify(res));
						this.realtorProperties = res.data.realtorProfiles;
						return this.realtorProperties;
					},
					(err) => {
						console.log("Feature-Update FAIL: " + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { }
				);
			} catch (error) {
				console.log("Form Invalid: " + JSON.stringify(error));
				this.alertService.error(error);
			}
		}

		getRealtorLastName(realtorProfile: any) {
			if (realtorProfile?.realtorProfileId) {
				const realtor = this.realtorProperties.find((e: any) => e.realtorProfileId == realtorProfile.realtorProfileId);
				return realtor?.lastName;
			}
			else {
				return '';
			}
		}

		/*********
		 * Add New Button
		 *
		 */
	onOpenFormAddProforma() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Proforma',
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);
				this.getAllSentEmailProforma(this.proformaSearchForm);

				// close the dialogBox
				dialogRef.close();
			});
	}

	fetchProformaById(proformaId: any) {
		try {
			//pass this.confId in parameter below in kbmresorts
			this.proformaService.findById(proformaId)
				.subscribe(
					(res: any) => {
						console.log('findAllproformaObj Data: ' + JSON.stringify(res));
						this.proformaObj = res.data.proforma;
						this.onOpenFormEditProforma(this.proformaObj);
						return this.proformaObj;
					},
					(err: any) => {
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		* Edit Button
		*
		*/
		onOpenFormEditProforma(proforma: Proforma) {
			console.log("Testing Proforma: "+ JSON.stringify(proforma));
			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.maxWidth = "100vw";
			dialogConfig.width = "80vw";
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				proforma: proforma,
				title: 'Edit Proforma'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);
					this.getAllSentEmailProforma(this.proformaSearchForm);

					// close the dialogBox
					 dialogRef.close();
				});

			dialogRef.componentInstance.doDelete.subscribe(
				data => {
					console.log('Dialog output:', data);
					this.getAllSentEmailProforma(this.proformaSearchForm);

					// close the dialogBox
					dialogRef.close();
				});
		}

		removeNullFromString(event: any) {
			var name = event.replaceAll('null', '');
			return name;
		}

		onActionSelection(event: any, property: any) {
			if(event.value == 1) {
				this.requestProforma(property);
			} else if(event.value == 2) {
				this.sendProforma(property, false);
			} else if(event.value == 3) {
				this.sendProforma(property, true);
			}
		}

		sendProforma(property: any, sendToRealtor: boolean) {
			let request: any = {
				mlsAllId : property.mlsAllId,
				realtorEmail : property.listingAgentEmail,
				realtorName : property.listingAgentName,
				realtorPhone : property.listingAgentPhone,
				sendToRealtor: sendToRealtor
			};
			try {
				this.loading = true;
				this.proformaService.sendProformaToRealtor(request).subscribe(
					(res: any) => {
						console.log("Realtor created SUCCESS: " + JSON.stringify(res));
						this.sendFullMail(res.data.proforma);
					},
					(err: any) => {
						console.log("property-request FAIL: " + JSON.stringify(err));
						this.alertService.error(err);
						this.loading = false;
					},
					() => {
						this.loading = false;
					}
				);
			} catch (error) {

			this.alertService.error(error);
			}
		}

		sendFullMail(proforma: any) {
			let property =  proforma.propertyLeadProfile;
			let propertyName = "";
			if(property?.subjAdrDevelopmentName != undefined)  {
			  propertyName = propertyName + property?.subjAdrDevelopmentName;
			}
			if(property?.subjAdrUnit != undefined) {
			  propertyName = propertyName == "" ? '#' + property?.subjAdrUnit : propertyName + " #" + property?.subjAdrUnit;
			}
			if(property?.subjAdrStreet != undefined && propertyName == "") {
			  propertyName = property?.subjAdrStreet;
			}

			let createdBy = proforma.createByProfile;
			let regards = '';
			regards = createdBy?.firstName != undefined ? createdBy?.firstName : '';
			regards = createdBy?.lastName != undefined ? regards == '' ? createdBy?.lastName : regards + ', ' + createdBy?.lastName: regards + '';
			regards = regards == '' ? createdBy?.emailAddress != undefined ? createdBy?.emailAddress : '' : regards + '<br>' + (createdBy?.emailAddress != undefined ? createdBy?.emailAddress : '');
			regards = regards == '' ? (createdBy?.mobilePhone != undefined ? createdBy?.mobilePhone : '') : (regards + '<br>' + (createdBy?.mobilePhone != undefined ? createdBy?.mobilePhone : ''));
			regards = regards == '' ? (createdBy?.title != undefined ? createdBy?.title : '') : (regards + '<br>' + (createdBy?.title != undefined ? createdBy?.title : ''));

			let realtorProfile = proforma.realtorProfile;
			const dialogConfig = new MatDialogConfig();
			this.msg = new Msg();
			this.msg.subject = 'Proforma Details';
			this.msg.emailHtml = 'Hi ' + (realtorProfile != undefined ? realtorProfile?.firstName : '')
			+ ' <br> <br> Please find your rent analysis for ' + propertyName
			+ ' <br> <br> <a href="'+ this.shareProformaEmail +'">'+ this.shareProformaEmail +'</a>'
			+ ' <br> <br> Please explore the income potential by selecting between Stable, Contracting, and Expanding markets to see how our analysis indicates your home will perform under varying economic conditions.'
			+ '<br> <br> I look forward to learning more about your home and am available to discuss anytime at your convenience. <br> <br>'
			+ 'Best, <br>'
			+ regards;

			this.msg.topic = 700; // 'proforma'
			this.msg.topicId = proforma.proformaId;

			// settings
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
			  title: "send mail",
			  msg: this.msg,
			  toEmails: realtorProfile?.emailAddress,
			  ccEmails: '',
			  bccEmails: '',
			  proforma: proforma
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef:any = this.dialog.open(SendFullMailComponent, dialogConfig);

			dialogRef.componentInstance.doAdd.subscribe((data:any) => {
			  console.log("Dialog output:", data);
			  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma?.name + ' shared successfully.', life: 3000 });
			  // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
			  // this.addMsgCB(data);

			  // close the dialogBox
			  // dialogRef.close();
			});
		  }

		requestProforma(property: any) {
			console.log(property)
			let request: any = {
				mlsAllId : property.mlsAllId,
				addressStreetNumber : property.addressStreetNumber,
				addressStreetName : property.addressStreetName,
				addressUnit : property.addressUnit,
				addressCity : property.addressCity,
				addressState : property.addressState,
				addressZip : property.addressZip,
			};
			try {
				this.loading = true;
				this.proformaService.requestProforma(request).subscribe(
					(res: any) => {
						console.log("property-request SUCCESS: " + JSON.stringify(res));
						this.showProforma(res.data.proforma);
					},
					(err: any) => {
						console.log("property-request FAIL: " + JSON.stringify(err));
						this.alertService.error(err);
						this.loading = false;
					},
					() => {
						this.loading = false;
					}
				);
			} catch (error) {

			this.alertService.error(error);
			}
		}

		showProforma(proforma: Proforma) {
			const dialogConfig = new MatDialogConfig();

			// settings
			dialogConfig.maxWidth = "100vw";
			dialogConfig.width = "80vw";
			dialogConfig.disableClose = false;
			dialogConfig.autoFocus = true;
			dialogConfig.hasBackdrop = true;

			// pass data, ie rateBuicket: this.shortTermRentalId,
			dialogConfig.data = {
				proforma: proforma,
				title: 'Edit Proforma'
			};

			// open the popup and get a reference to it called dialogRef
			const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

			// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
			dialogRef.componentInstance.doUpdate.subscribe(
				data => {
					console.log('Dialog output:', data);

					// close the dialogBox
					// dialogRef.close();
				});

			// to open the copied proforma
			dialogRef.componentInstance.doOpenCopiedProforma.subscribe(
				data => {
					console.log('doOpenCopiedProforma Dialog output:', data);
					// close the dialogBox
					if(data != undefined) {

					}
					dialogRef.close();
				});
		}

		/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazyForRealEstate(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent1 = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-realEstate-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			// if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
			// }
			event.multiSortMeta = [];
			event.multiSortMeta.push({ field: 'listingDate', order: -1 });

			const pageNumber = Math.round(event.first / event.rows);
			this.realEstateService.findByRealEstateAllSummary(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal1 = res.page.recordTotal;
						this.realEstates = res.data.realEstates;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.realEstates = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getImageURL(realEstate: any){

		let url = "https://s3.us-east-1.amazonaws.com/img.kbmrealestate.com/residential.jpg";
		if(realEstate?.numOfPictures > 0 && realEstate.kbmPropertyType){
			url = 'https://s3.us-east-1.amazonaws.com/img.kbmrealestate.com/' + realEstate?.mlsName +'/img-'
				+ realEstate?.mlsName + '-'+ realEstate?.kbmPropertyType + '-'+ realEstate?.mlsNumber + '_1.jpg'
			url = url.toLowerCase();

		}
		console.log("fav property URL : "+url);

		return url;
	}

	formatCurrency(text: any) {
		return Utils.formatPriceNoFractionDigits(text);
	}


}
